<template>
  <div>
    <div class="top">
      <div class="main-width py-5">
        <VBreadcrumb
          :options="[{ label: '首页', to: '/' }, { label: '邮轮航线' }]"
        ></VBreadcrumb>
      </div>
      <section class="main-width" v-if="adStore.state && adStore.state.length">
        <swiper :options="swiperOptions" class="mySwiper">
          <swiper-slide v-for="(item, index) in adStore.state" :key="index">
            <a
              class="block h-full"
              :href="item.url"
              :title="item.title"
              :target="item.target"
            >
              <img class="swiper-img" :alt="item.title" :src="item.path_url" />
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" />
        </swiper>
      </section>
    </div>
    <section class="box">
      <div class="main-width">
        <ScrollNav
          tag="nav"
          class="mb-3 sticky bg-white z-10"
          :style="{ top: `${stickyOffsetTop}px` }"
          :options="navs"
          :offset="scrollToOffset"
        />
        <!-- <template v-for="(item, index) in detail"> -->
        <div
          v-for="(item, index) in routes"
          class="collapse"
          :id="genSectionId(item.id)"
        >
          <div class="item" @click="toggleStatus(index)">
            <div class="route-name">{{ item.name }}</div>
            <div class="status">
              {{ status[index] ? "收起" : "展开" }}
              <span
                class="arrow"
                :class="{
                  rotateUp: status[index],
                  rotateDown: !status[index],
                }"
              >
                <i class="ficon ficon-arrow-bottom"></i>
              </span>
            </div>
          </div>
          <el-collapse-transition>
            <div
              class="content"
              v-show="status[index]"
              :style="{ paddingTop: status[index] ? '10px' : '0px' }"
            >
              <product-collection
                @more="moreFunc"
                :collection="item.list"
              ></product-collection>
            </div>
          </el-collapse-transition>
        </div>
        <!-- </template> -->
      </div>
    </section>
    <AppDock />
  </div>
</template>
<script>
import {
  defineComponent,
  useMeta,
  ref,
  useFetch,
  computed,
} from "@nuxtjs/composition-api";
import { getAllRouteList } from "@/services/destination";
import ElCollapseTransition from "element-ui/lib/transitions/collapse-transition";
import VBreadcrumb from "@/components/VBreadcrumb.vue";
import ProductCollection from "@/components/Product-collection.vue";
import usePlatformAdvertBanner from "~/composables/usePlatformAdvertBanner";
import useLayout from "~/composables/useLayout";
import ScrollNav from "~/components/ScrollNav.vue";
import AppDock from '~/components/layouts/AppDock.vue'

import { useAsyncState } from "@vueuse/core";
import { REQUEST_CODES } from "~/constants/const-http";

import {set} from '~/utils/helpers'

export default defineComponent({
  name: "destination",
  auth: false,
  head: {},
  layout: "Main",
  setup() {
    useMeta(() => ({
      title: "邮轮航线",
    }));
    const status = ref([]);
    const adStore = ref(usePlatformAdvertBanner(43));

    const { state, execute } = useAsyncState(
      async () => {
        const { msg, data, code } = await getAllRouteList();
        if (code !== REQUEST_CODES.ERROR_OK) {
          throw new Error(msg);
        }
        return data;
      },
      [],
      {
        immediate: false,
        onSuccess: (res) => {
          // status.value = res.reduce((status, item, index) => {
          //   set(status, index, true);
          //   return status;
          // }, {});
          status.value = res.map(item => true)
        },
        onError: (err) => console.error(err),
      }
    );
    useFetch(async () => {
      await execute(0);
    });
    const genSectionId = (id) => `section-${id}`;

    const { headerSize } = useLayout();
    const scrollToOffset = computed(() => headerSize.height + 50);
    const stickyOffsetTop = computed(() => headerSize.height);
    const routes = computed(() =>
      state.value.map((item) => {
        let routes = [];
        if (item.product && item.product.length) {
          routes.push({
            id: "-9999",
            name: "平台推荐",
            product: [...item.product],
          });
        }

        routes = routes.concat(
          item.routeTwo.filter((p) => p.product.length > 0)
        );
        return {
          ...item,
          list: routes,
        };
      })
    );

    const navs = computed(() =>
      routes.value.map((item) => ({
        text: item.name,
        sectionSelector: `#${genSectionId(item.id)}`,
      }))
    );
    return {
      status,
      adStore,
      detail: state,
      navs,
      scrollToOffset,
      genSectionId,
      stickyOffsetTop,
      routes,
    };
  },
  data() {
    return {
      // status: {
      //   0: true,
      // },
      //   detail: [],
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: true,
        lazy: true,
        loop: true,
      },
    };
  },
  components: {
    ElCollapseTransition,
    VBreadcrumb,
    ProductCollection,
    ScrollNav,
    AppDock
  },
  methods: {
    toggleStatus(index) {
      if (this.status[index]) {
        this.$set(this.status, index, !this.status[index]);
      } else {
        this.$set(this.status, index, true);
      }
      window.scrollTo(0, window.scrollY + 1); //触发图片懒加载
    },
    formatData(item) {
      let arr = [];
      if (item.product && item.product.length) {
        //设置平台推荐
        arr.push({
          id: "-9999",
          name: "平台推荐",
          product: item.product,
        });
      }
      let route = item.routeTwo.filter((p) => p.product.length); //去除无产品航线
      arr = arr.concat(route);
      return arr;
    },
    moreFunc(data) {
      //线路详情
      console.log(data);
      this.$router.push(`/destination/list?route_id=${data}`);
    },
  },
  //   async fetch() {
  //     const { msg, data, code } = await getAllRouteList();
  //     if (code === 10000 || code === 200) {
  //       this.detail = data;
  //     } else {
  //       this.$message({
  //         type: "error",
  //         text: msg,
  //       });
  //     }
  //   },
});
</script>
<style lang="scss" scoped>

.mySwiper {
  height: 240px;
  width: 100%;
  margin-bottom: 30px;
  .swiper-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.box {
  background-color: #fff;
  padding-bottom: 30px;
  background-color: #fff;
  padding-bottom: 30px;
}

.collapse {
  width: 100%;
  width: 100%;

  .item {
    height: 60px;
    background-color: #f3f5f8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    .route-name {
      font-size: 24px;
      color: #3d3d3d;
      font-weight: 500;
    }
    .status {
      font-size: 16px;
      color: #3d3d3d;
      .arrow {
        transition: all 0.4s linear;
        display: inline-block;
      }

      .rotateUp {
        transform: rotate(180deg);
      }

      .rotateDown {
        transform: rotate(0deg);
      }
    }
  }
  .content {
    transition: all 0.4s;
  }
}

</style>
